import React from 'react';
import { css } from '@emotion/core';
import ShareIconButton from '../ShareIconButton';

const LineShareButton = ({ url }) => {
    return (
        <ShareIconButton
            variant="contained"
            text="LINE"
            bgColor="#06c755"
            imageUrl="https://assets.fevercdn.com/promotion/img/line.svg"
            url={`https://line.me/R/msg/text/?${encodeURIComponent(url)}`}
            size={28}
            style={lineButtonStyle}
        />
    );
};

export default LineShareButton;

const lineButtonStyle = css`
    color: #ffffff;
    padding: 10px;
`;
